//Custom components
import StatCard from '../../../UI/Card/StatCard';

const ClosedOutProjects = ({ count }: { count: number }) => {
  return <StatCard title='Closed Out Projects' stat={count} />;
};

export default ClosedOutProjects;
